import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { v4 } from "uuid";
import {
    AggregatedProductInterface,
    ProductInterface,
} from "../../interfaces/products";
import { RootState } from "../../reducers/store";
import ProductCard from "../general/cards/product";
import CompanyInfo from "../general/companyInfo";
import Spinner from "../vapor/spinner";
import "./style.scss";

interface SearchCompanyProductsProps {
    onBuyAggregatedProducts: (value: AggregatedProductInterface) => void;
    onBuyProduct: (value: any) => void;
    onNextStep: () => void;
    onClose: () => void;
    expanded?: boolean;
}

const SearchCompanyProductsComponent = (props: SearchCompanyProductsProps) => {
    const aggregatedProducts = useSelector(
        (state: RootState) => state.aggregatedProducts,
    );
    const allProducts = useSelector((state: RootState) => state.products);
    const search = useSelector((state: RootState) => state.search);
    const products = search.products;

    const buyableProducts: ProductInterface[] = products.products
        .map((item) => {
            return allProducts.data.find(
                (product) => product.product === item.product,
            )!;
        })
        .filter(
            (item) =>
                !(
                    item &&
                    item.formats.length === 1 &&
                    item.formats[0].toUpperCase() === "JSON"
                ),
        );

    return (
        <>
            <div
                className={
                    "searchRoot searchProducts" +
                    (props.expanded ? " expanded" : "")
                }
            >
                {products.products && products.name && (
                    <div className="searchProducts-header">
                        <CompanyInfo />
                        <div className="searchProducts-header-close">
                            <FontAwesomeIcon
                                onClick={() => props.onClose()}
                                icon={faTimes}
                            />
                        </div>
                    </div>
                )}
                <div className="searchResults">
                    {products.isGettingCompanyProducts && (
                        <div
                            className="searchResultsSpinner"
                            style={{ marginTop: 32 }}
                        >
                            <Spinner />
                        </div>
                    )}
                    {aggregatedProducts.data &&
                        aggregatedProducts.data.length > 0 &&
                        !aggregatedProducts.isGettingAggregatedProducts &&
                        aggregatedProducts.data.map((aggregatedProduct) => {
                            let pKey = v4();

                            const productsList = aggregatedProduct.products;

                            const aggregatedBuyableProducts =
                                buyableProducts.filter((buyableProduct) => {
                                    return (
                                        buyableProduct &&
                                        productsList.find(
                                            (productInList) =>
                                                productInList ===
                                                buyableProduct.product,
                                        )
                                    );
                                });
                            const areAllProductsAvailableForCompany =
                                aggregatedBuyableProducts.length ===
                                productsList.length;

                            if (!areAllProductsAvailableForCompany) return null;

                            return (
                                <ProductCard
                                    id={`bis-product-card_${pKey}`}
                                    key={`bis-product-card_${pKey}`}
                                    item={{
                                        name: aggregatedProduct.name,
                                        description:
                                            aggregatedProduct.description,
                                        formats: aggregatedBuyableProducts
                                            .map((aggregatedBuyableProduct) => {
                                                return aggregatedBuyableProduct.formats;
                                            })
                                            .flat(),
                                        price: aggregatedBuyableProducts.reduce(
                                            (
                                                acc: number,
                                                aggregatedBuyableProduct: any,
                                            ) => {
                                                return (
                                                    acc +
                                                    aggregatedBuyableProduct.price
                                                );
                                            },
                                            0,
                                        ),
                                        product: aggregatedProduct.products,
                                    }}
                                    onSelect={() =>
                                        props.onBuyAggregatedProducts(
                                            aggregatedProduct,
                                        )
                                    }
                                />
                            );
                        })}
                    {products &&
                        products.products &&
                        !products.isGettingCompanyProducts &&
                        buyableProducts.map((item: any) => {
                            let pKey = v4();

                            return (
                                <ProductCard
                                    id={`bis-product-card_${pKey}`}
                                    key={`bis-product-card_${pKey}`}
                                    item={item}
                                    onSelect={() => props.onBuyProduct(item)}
                                />
                            );
                        })}
                </div>
            </div>
        </>
    );
};

export default SearchCompanyProductsComponent;
